import React, { useEffect } from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const CustomTooltip = ({ active, payload, label, areachartData }) => {
    if (active && payload && payload.length) {
        return (
            <div className="custom-tooltip-area">
                <p className="label">{`${label}`}</p>
                <p className="desc">{`Loans: ${payload[0].value}`}</p>
            </div>
        );
    }

    return null;
};

const Areachart = ({ areachartData }) => {
    let datanew = [];

    // Check if areachartData is defined and not null
    if (areachartData && typeof areachartData === 'object') {
        Object.entries(areachartData).map((hb, k) => {
            datanew.push({
                name: hb[1].date,
                uv: hb[1].totalLoans,
                amt: hb[1].totalLoans
            });
        });
    } else {
        console.error('areachartData is not defined or null');
    }


    return (
        <ResponsiveContainer width="100%" height={250}>
            <AreaChart
                width={200}
                height={200}
                data={datanew}
                margin={{
                    top: 20,
                    right: 40,
                    left: 0,
                    bottom: 0,
                }}
            >
                <defs>
                    <linearGradient id="colorUvBlue" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="5%" stopColor="#236987" stopOpacity={0.8} />
                        <stop offset="95%" stopColor="#3e8baa" stopOpacity={0.2} />
                    </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis style={{ fontSize: '8px' }} dataKey="name" axisLine={false} />
                <YAxis axisLine={false} />
                <Tooltip content={<CustomTooltip />} />
                <Area type="monotone" dataKey="uv" stroke="#236987" strokeWidth={3} dot={{ stroke: '#236987', strokeWidth: 2, r: 5, fill: 'white' }} activeDot={{ stroke: '#236987', strokeWidth: 6, r: 8, fill: 'white' }} fill="url(#colorUvBlue)" />
            </AreaChart>
        </ResponsiveContainer>
    );
};

export default Areachart;
